// let BaseUrl
// let host = window.location.host
// switch (host) {
// 	case 'dev-agent-pc.mingtaokeji.com':
// 		// 测试
// 		BaseUrl = 'http://dev-skw2.mingtaokeji.com'
// 		break
// 	case 'agent-learn.mtcloudedu.com ':
// 		// 正式
// 		BaseUrl = 'https://api.mtcloudedu.com'
// 		break
// 	default:
// 		// 生产
// 		BaseUrl = 'http://app.sungoedu.com'
// 		break
// }
export function BaseUrl() {
 // let host = window.location.host
  // if (host === 'dev-channel.mtcloudedu.com') {
  //   return 'https://api.mtskedu.com'
  // } else if (host === 'agent-learn.mtskedu.com') {
  //   return 'https://api.mtskedu.com'
  // } else {
  //   // return 'http://192.168.1.68:8082'
  //  return 'https://api.mtskedu.com'
  // }
  let host = window.location.host
  if (host === 'dev-channel.mtcloudedu.com') {
    return 'https://dev-api.mtcloudedu.com'
  } else if (host === 'agent-learn.mtskedu.com') {
    return 'https://api.mtskedu.com'
  } else {
    return 'https://api.mtskedu.com'
    // return 'http://192.168.1.68:8082'
  }
}
